import { Space, Tag, Typography } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';

import { formatDisplayId, getTargetString, getWorkKindMeta } from '@/pages/ugc-reports/utils';

import type { UgcReportTicket } from '@/services/ugc-reports';

type Props = {
    record: UgcReportTicket;
};

const WorkKindCell: React.FC<Props> = ({ record }) => {
    const { formatMessage } = useIntl();
    const workKind = record.work_kind;

    if (!workKind) return <>-</>;

    const meta = getWorkKindMeta(workKind);
    const kindLabel = formatMessage({ id: `ugcReports.workKind.${workKind}` });

    if (workKind !== 'DRAMA_EPISODE') {
        return <Tag color={meta?.color ?? 'default'}>{kindLabel}</Tag>;
    }

    const dramaId = record.drama_id || getTargetString(record.target, 'drama_id');
    const episodeNo = getTargetString(record.target, 'episode_no');

    return (
        <Space direction="vertical" size={4}>
            <Space size={8} wrap>
                <Tag color={meta?.color ?? 'default'}>{kindLabel}</Tag>
                {episodeNo ? (
                    <Typography.Text type="secondary" style={{ fontSize: 12 }}>
                        <FormattedMessage
                            id="ugcReports.columns.episodeNo"
                            values={{ no: episodeNo }}
                        />
                    </Typography.Text>
                ) : null}
            </Space>
            {dramaId ? (
                <Typography.Text copyable={{ text: dramaId }} type="secondary" style={{ fontSize: 12 }}>
                    {formatDisplayId(dramaId)}
                </Typography.Text>
            ) : null}
        </Space>
    );
};

export default WorkKindCell;
